module.exports = __webpack_public_path__ + "static/media/boy-three.046668f9.jpg";